import { useTranslation } from 'react-i18next'

import { validateWaterDensityValue } from './draftValidationUtils'

const useWaterDensityValidation = () => {
  const { t } = useTranslation()

  const getWaterDensityValidationRules = () => [
    {
      validator: (_, value) => {
        const { isValid, errorType } = validateWaterDensityValue(value)

        if (!isValid) {
          return Promise.reject(
            new Error(t(`portCall.draftSurvey.${errorType}`))
          )
        }

        return Promise.resolve()
      },
    },
  ]

  return {
    getWaterDensityValidationRules,
  }
}

export default useWaterDensityValidation
